module.exports = __webpack_public_path__ + "static/media/item-incorrect.3b014467.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/school_money/item-incorrect.svg
// module id = 722
// module chunks = 0